<div class="appointment-wrap">
  <calendar class="apmt-calendar"
    [anniversaries]="anniversaries"
    [short-anniversary]="3"
    (onDaySelected)="onDaySelected($event)"
    (onMonthChanged)="onMonthChanged($event)">
  </calendar>
  <div appointment-noevent class="apmt-event"
    [hidden]="isExistDayEvent"></div>
  <div appointment-packet class="apmt-event appointment"
    *ngIf="dayPacket"
    [packet]="dayPacket"
    [date]="dayAppointmentTime"></div>
  <div appointment-holyday class="apmt-event holy"
    *ngIf="holydayDesc"
    [desc]="holydayDesc"></div>
  <div appointment-payment class="apmt-event payment"
    *ngIf="dayPayment"
    [date]="dayPayment"></div>
  <div appointment-attendance class="apmt-event attendance"
    *ngIf="isAttendanceDay"></div>
  <div appointment-event class="apmt-event event"
    *ngFor="let event of dayEvents"
    [desc]="event"></div>
  <div appointment-status class="apmt-status"
    [packet]="packet"
    [link]="child.centerPhone"></div>
  <child-info-packet class="apmt-packet"
    [packet]="packet"></child-info-packet>
</div>
